/* eslint no-unused-expressions: 0, react/no-danger: 0 */
import React, { useEffect, useRef } from 'react';
import Observer from 'react-intersection-observer';
import { Link } from "react-router-dom";
import content from '../../content';
import { GAfireEvent } from '../Tracking';
import { fireTag } from '../../libs/analytics';
import ArrowRightWhite from "../../images/arrow__right-indigo.svg";

const Committed = (props) => {
	// props.setEnableScrollGA = undefined;
	const copy = content.sustainability.committed;

	const containerRef = useRef(null)

	useEffect(() => {
	})

	let scrollCommitted = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollCommitted && document.querySelector('#sustainability__committed').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollCommitted = true;
				fireTag('S7');
			}
		});
	},[])

	return (
		// <section
		// 	className="home__committed"
		// 	id="grant-process"
		// 	ref={containerRef}
		// >
		<Observer
			tag='section'
			className="sustainability__committed"
			id="sustainability__committed"
			ref={containerRef}
			triggerOnce
			threshold={0.25}
			onChange={(inView) => {
				if (inView) {
					// GAfireEvent('isf_S5');
					//fireTag('S7');
				}
			}}
		>
			<div className='container-copy'>
				<div className="committed__copy">
					<div className='bar'/>
					<h2 tabIndex="-1" dangerouslySetInnerHTML={{__html: copy.headline}}/>

					<Link to="/" className="p"  rel="noreferrer" onClick={() => {
						//GAfireEvent('isf_C23', {label: `${copy.copy.toLowerCase()}`});
						fireTag('C9');
					}}>
						{copy.copy}
					</Link>
				</div>
			</div>
			<div className='container-img' role="img" aria-label={copy.alt}/>
		</Observer>
	);
};

export default Committed;
